var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"storeinformation"},[(_vm.datas.styleType !== 3)?_c('div',{style:({
      background: _vm.datas.backColor,
      'padding-top': _vm.datas.paddingTop + 'px',
      'padding-bottom': _vm.datas.paddingBottom + 'px',
      'padding-left': _vm.datas.paddingLeft + 'px',
      'padding-right': _vm.datas.paddingRight + 'px',
      'border-style': _vm.datas.borderStyle,
      'border-color': _vm.datas.borderColor,
      'border-width': _vm.datas.borderLineWeight + 'px',
      'border-radius': _vm.datas.borderRadius + 'px',
      'margin-top': _vm.datas.marginTop + 'px',
      'margin-bottom': _vm.datas.marginBottom + 'px',
      'margin-left': _vm.datas.marginLeft + 'px',
      'margin-right': _vm.datas.marginRight + 'px',
    })},[(_vm.datas.styleType === 1)?_c('section',{staticClass:"goods_list_con goods_list_con1"},[(_vm.vpnInfo.storeImg)?_c('div',{staticClass:"goods_img_con"},[_c('img',{attrs:{"draggable":"false","src":_vm.vpnInfo.storeImg,"alt":""}})]):_vm._e(),_c('div',{staticClass:"goods_info_con"},[_c('div',{staticClass:"name_con",style:({
            color: _vm.datas.wordColor,
            'font-size': _vm.datas.wordSize + 'px',
            'font-weight': _vm.datas.isBold ? 'bold' : 'normal',
            'font-style': _vm.datas.isTilt ? 'italic' : 'normal',
            'text-decoration': _vm.datas.isUnderLine ? 'underline' : 'none',
          })},[_vm._v(" "+_vm._s(_vm.vpnInfo.Name)+" ")]),_c('div',[_c('div',{staticClass:"store_info_con",on:{"click":function($event){return _vm.phone(_vm.vpnInfo)}}},[_c('div',[(_vm.datas.phoneImageUrl)?_c('img',{attrs:{"draggable":"false","src":_vm.datas.phoneImageUrl,"alt":""}}):_c('i',{staticClass:"iconfont icon-dianhua"}),_c('span',{staticClass:"store_text_con",style:({
                  color: _vm.datas.wordColorSmallContent,
                  'font-size': _vm.datas.wordSizeSmallContent + 'px',
                  'font-weight': _vm.datas.isBoldSmallContent ? 'bold' : 'normal',
                  'font-style': _vm.datas.isTiltSmallContent
                    ? 'italic'
                    : 'normal',
                  'text-decoration': _vm.datas.isUnderLineSmallContent
                    ? 'underline'
                    : 'none',
                })},[_vm._v(_vm._s(_vm.vpnInfo.Phone))])]),_vm._m(0)]),_c('div',{staticClass:"store_info_con",on:{"click":function($event){return _vm.toAddress(_vm.vpnInfo)}}},[_c('div',[(_vm.datas.addressImageUrl)?_c('img',{attrs:{"draggable":"false","src":_vm.datas.addressImageUrl,"alt":""}}):_c('i',{staticClass:"iconfont icon-dingwei"}),_c('span',{staticClass:"store_text_con",style:({
                  color: _vm.datas.wordColorSmallContent,
                  'font-size': _vm.datas.wordSizeSmallContent + 'px',
                  'font-weight': _vm.datas.isBoldSmallContent ? 'bold' : 'normal',
                  'font-style': _vm.datas.isTiltSmallContent
                    ? 'italic'
                    : 'normal',
                  'text-decoration': _vm.datas.isUnderLineSmallContent
                    ? 'underline'
                    : 'none',
                })},[_vm._v(_vm._s(_vm.vpnInfo.Address))])]),_vm._m(1)])])])]):_vm._e(),(_vm.datas.styleType === 2)?_c('section',{staticClass:"goods_list_con goods_list_con2"},[_c('div',{staticClass:"f-bt c-m-b-15"},[_c('div',{staticClass:"ft-32",style:({
            color: _vm.datas.wordColor,
            'font-size': _vm.datas.wordSize + 'px',
            'font-weight': _vm.datas.isBold ? 'bold' : 'normal',
            'font-style': _vm.datas.isTilt ? 'italic' : 'normal',
            'text-decoration': _vm.datas.isUnderLine ? 'underline' : 'none',
          })},[_vm._v(" "+_vm._s(_vm.vpnInfo.Name)+" ")]),_c('div',[_c('span',{style:({
              color: _vm.datas.wordColorSmallTitle,
              'font-size': _vm.datas.wordSizeSmallTitle + 'px',
              'font-weight': _vm.datas.isBoldSmallTitle ? 'bold' : 'normal',
              'font-style': _vm.datas.isTiltSmallTitle ? 'italic' : 'normal',
              'text-decoration': _vm.datas.isUnderLineSmallTitle
                ? 'underline'
                : 'none',
            })},[_vm._v("营业时间: ")]),_c('span',{style:({
              color: _vm.datas.wordColorSmallContent,
              'font-size': _vm.datas.wordSizeSmallContent + 'px',
              'font-weight': _vm.datas.isBoldSmallContent ? 'bold' : 'normal',
              'font-style': _vm.datas.isTiltSmallContent ? 'italic' : 'normal',
              'text-decoration': _vm.datas.isUnderLineSmallContent
                ? 'underline'
                : 'none',
            })},[_vm._v(_vm._s(_vm.vpnInfo.BusinessStartTime)+"-"+_vm._s(_vm.vpnInfo.BusinessEndTime))])])]),_c('div',{staticClass:"f-bt c-m-b-15",on:{"click":function($event){return _vm.phone(_vm.vpnInfo)}}},[_c('div',[_c('div',{staticClass:"c-m-b-5",style:({
              color: _vm.datas.wordColorSmallTitle,
              'font-size': _vm.datas.wordSizeSmallTitle + 'px',
              'font-weight': _vm.datas.isBoldSmallTitle ? 'bold' : 'normal',
              'font-style': _vm.datas.isTiltSmallTitle ? 'italic' : 'normal',
              'text-decoration': _vm.datas.isUnderLineSmallTitle
                ? 'underline'
                : 'none',
            })},[_vm._v(" 电话 ")]),_c('div',{style:({
              color: _vm.datas.wordColorSmallContent,
              'font-size': _vm.datas.wordSizeSmallContent + 'px',
              'font-weight': _vm.datas.isBoldSmallContent ? 'bold' : 'normal',
              'font-style': _vm.datas.isTiltSmallContent ? 'italic' : 'normal',
              'text-decoration': _vm.datas.isUnderLineSmallContent
                ? 'underline'
                : 'none',
            })},[_vm._v(" "+_vm._s(_vm.vpnInfo.Phone)+" ")])]),_c('div',{staticClass:"img_info_con"},[(_vm.datas.phoneImageUrl)?_c('img',{attrs:{"draggable":"false","src":_vm.datas.phoneImageUrl,"alt":""}}):_c('i',{staticClass:"iconfont icon-dianhua"})])]),_c('div',{staticClass:"f-bt",on:{"click":function($event){return _vm.toAddress(_vm.vpnInfo)}}},[_c('div',[_c('div',{staticClass:"c-m-b-5",style:({
              color: _vm.datas.wordColorSmallTitle,
              'font-size': _vm.datas.wordSizeSmallTitle + 'px',
              'font-weight': _vm.datas.isBoldSmallTitle ? 'bold' : 'normal',
              'font-style': _vm.datas.isTiltSmallTitle ? 'italic' : 'normal',
              'text-decoration': _vm.datas.isUnderLineSmallTitle
                ? 'underline'
                : 'none',
            })},[_vm._v(" 门店地址 ")]),_c('div',{style:({
              color: _vm.datas.wordColorSmallContent,
              'font-size': _vm.datas.wordSizeSmallContent + 'px',
              'font-weight': _vm.datas.isBoldSmallContent ? 'bold' : 'normal',
              'font-style': _vm.datas.isTiltSmallContent ? 'italic' : 'normal',
              'text-decoration': _vm.datas.isUnderLineSmallContent
                ? 'underline'
                : 'none',
            })},[_vm._v(" "+_vm._s(_vm.vpnInfo.Address)+" ")])]),_c('div',{staticClass:"img_info_con"},[(_vm.datas.addressImageUrl)?_c('img',{attrs:{"draggable":"false","src":_vm.datas.addressImageUrl,"alt":""}}):_c('i',{staticClass:"iconfont icon-dingwei"})])])]):_vm._e()]):_c('div',[_c('select-store-entrance')],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('i',{staticClass:"iconfont icon-xiangyou"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('i',{staticClass:"iconfont icon-xiangyou"})])}]

export { render, staticRenderFns }